import { px2rem, PB2Bold } from '@moim/common';
import { Svg24LabelFilter, Svg18Search2, Svg24CalendarG } from '@moim/icons';
import styled from 'styled-components';

var LabelFilterIcon = styled(Svg24LabelFilter).attrs(function (props) {
  return {
    size: "s",
    touch: 24,
    role: "button",
    iconColor: props.theme.colorV2.colorSet.grey800
  };
}).withConfig({
  displayName: "LabelFilterIcon",
  componentId: "sc-5tdzat-0"
})([""]);
var SearchIcon = styled(Svg18Search2).attrs(function (props) {
  return {
    size: "s",
    touch: 24,
    role: "button",
    iconColor: props.theme.colorV2.colorSet.grey800
  };
}).withConfig({
  displayName: "SearchIcon",
  componentId: "sc-5tdzat-1"
})([""]);
var CalendarIcon = styled(Svg24CalendarG).attrs(function (props) {
  return {
    size: "s",
    touch: 24,
    role: "button",
    iconColor: props.theme.colorV2.colorSet.grey800
  };
}).withConfig({
  displayName: "CalendarIcon",
  componentId: "sc-5tdzat-2"
})([""]);
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-5tdzat-3"
})(["width:100%;height:", ";padding:", ";display:flex;align-items:center;justify-content:space-between;position:relative;"], px2rem(48), px2rem(10));
var ButtonGroup = styled.div.withConfig({
  displayName: "ButtonGroup",
  componentId: "sc-5tdzat-4"
})(["display:flex;align-items:center;gap:", ";margin-", ":auto;"], px2rem(10), function (props) {
  return props.$position === "left" ? "right" : "left";
});
var MonthDisplay = styled(PB2Bold).withConfig({
  displayName: "MonthDisplay",
  componentId: "sc-5tdzat-5"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);color:", ";"], function (props) {
  return props.theme.colorV2.colorSet.grey800;
});

export { ButtonGroup, CalendarIcon, Container, LabelFilterIcon, MonthDisplay, SearchIcon };
